/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_V2_Library_Load_FailedInputs */

const en_home_v2_library_load_failed = /** @type {(inputs: Home_V2_Library_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Files could not be loaded`)
};

const es_home_v2_library_load_failed = /** @type {(inputs: Home_V2_Library_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudieron cargar los archivos`)
};

/**
* | output |
* | --- |
* | "Files could not be loaded" |
*
* @param {Home_V2_Library_Load_FailedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const home_v2_library_load_failed = /** @type {((inputs?: Home_V2_Library_Load_FailedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_V2_Library_Load_FailedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_v2_library_load_failed(inputs)
	return en_home_v2_library_load_failed(inputs)
});